import { SettingsFormRoot } from "./SettingsFormRoot/SettingsFormRoot";
import { SettingsFormSection } from "./SettingsFormSection/SettingsFormSection";
import { SettingsFormSectionTitle } from "./SettingsFormSection/SettingsFormSectionTitle/SettingsFormSectionTitle";

export const Root = SettingsFormRoot;
export const Section = SettingsFormSection;
export const SectionTitle = SettingsFormSectionTitle;
